import { createRootRoute } from '@tanstack/react-router';
import { RootComponent } from '@/app/route-components/RootComponent';
import { NotFoundPage } from '@/pages/errors/ui/NotFoundPage';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});
